import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import './paywall.css';
import WelcomeButton from '../TrialWelcome/WelcomeButton';

interface ConfirmationProps {
  setShowConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
}

const Confirmation: FC<ConfirmationProps> = ({ setShowConfirmation }) => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    setShowConfirmation(false);
    navigate('/roadmap', { replace: true });
  };

  return (
    <>
      <Box className="modal-outer" />
      <Box className="modal-inner2">
        <Box className="confirmation-container">
          <h2 className="confirmation-title">Thank you for your payment!</h2>
          <p className="confirmation-desc">We hope you continue enjoying MuseFlow.</p>
          <WelcomeButton onClick={handleRedirect} style={{ width: '200px' }}>
            LET&apos;S FLOW
          </WelcomeButton>
        </Box>
      </Box>
    </>
  );
};

export default Confirmation;
